export const SUPPLIER_NAV_KEYS = {
  phoneCalls: "supplier-phone-calls",
  inbox: "inbox",
};

export const SUPPLIER_VIEWS = {
  PHONE_CALLS: {
    viewId: SUPPLIER_NAV_KEYS.phoneCalls,
    path: `/${SUPPLIER_NAV_KEYS.phoneCalls}`,
    title: "Phone calls",
  },
  INBOX: {
    viewId: SUPPLIER_NAV_KEYS.inbox,
    path: `/${SUPPLIER_NAV_KEYS.inbox}`,
    title: "Inbox",
  },
};
